//import { configurationForToken } from "../CommonConstants";
import apiClient from "./apiClient";
import {Config} from "../Config";
import { configurationForToken } from "../CommonConstants";

const registerPushNotifications = async (token) => {
  if(!isPushNotificationSupported()){
    return;
  }
  if(Notification.permission !== "granted"){
    await askUserPermission();
    if(Notification.permission !== "granted"){
      throw new Error( "Se denegó el permiso para recibir notificaciones");
    }
  }
  await registerServiceWorker();
  let subscription = await getUserSubscription();
  if(!subscription){
    subscription = await createNotificationSubscription(Config.PUSH_NOTIFICATIONS_PUBLIC_KEY);
    sendSubscriptionToServer(subscription, token);
  }
  return subscription;
}

const sendSubscriptionToServer = (userSubscription, token) => {
  return apiClient.post("/admin/push/subscription/", userSubscription,configurationForToken(token));
};

function isPushNotificationSupported() {
  return "serviceWorker" in navigator && "PushManager" in window;
}

async function askUserPermission() {
  return await Notification.requestPermission();
}

function registerServiceWorker() {
  return navigator.serviceWorker.register("/sw.js");
}

async function createNotificationSubscription(pushServerPublicKey) {
  const serviceWorker = await navigator.serviceWorker.ready;
  return await serviceWorker.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: pushServerPublicKey,
  });
}

function getUserSubscription() {
  return navigator.serviceWorker.ready
    .then(function (serviceWorker) {
      return serviceWorker.pushManager.getSubscription();
    })
    .then(function (pushSubscription) {
      return pushSubscription;
    });
}

export default {
  registerPushNotifications,
};



// WEBPACK FOOTER //
// ./src/Services/PushNotificationService.js